import { Permission } from "@hex-insights/roadium.shared";
import { newPageInfo, newRouteParamsType } from "@hex-insights/router";
import { permissionHubPageInfo } from "../pageinfo";

type PermissionForRouteTitle = Pick<Permission, "id">;

export const permissionHubDetailPageInfo = newPageInfo({
	name: "Permission Detail",
	title: (e: PermissionForRouteTitle) => e.id,
	description: "Detail page for an permission.",
	exact: false,
	isLeaf: true,
	to: (id: Permission["id"]) => permissionHubPageInfo.to + `/${id}`,
	path: permissionHubPageInfo.path + "/:permissionID(\\d+)",
	parent: permissionHubPageInfo,
	paramsType: newRouteParamsType(permissionHubPageInfo.paramsType, "permissionID"),
});
